import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type SeaCardDeleteModalState = boolean;

const initialSeaCardDeleteModalState: SeaCardDeleteModalState = false;

const seaCardDeleteModalSlice = createSlice({
  name: "SeaCardDeleteModal",
  initialState: initialSeaCardDeleteModalState,
  reducers: {
    openDeleteCardModalAction: () => {
      return true;
    },
    closeDeleteModalAction: () => {
      return false;
    },
  },
});

const seaCardDeleteModalBaseSelector = createBaseSelector(seaCardDeleteModalSlice);

registerSlice([seaCardDeleteModalSlice]);

export const seaCardDeleteModalStore = {
  actions: seaCardDeleteModalSlice.actions,
  selectors: {
    seaCardDeleteModal: createSelector(seaCardDeleteModalBaseSelector, (s) => s),
  },
};
